<template>
    <div>
        <base-crud
            :ref="table"
            :crudName="crudName"
            :newText="newText"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint='endPoint'
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :dataForm="dataForm"
            @fieldUpdated="fieldUpdated"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'
    export default {
        data() {
            return {
                crudName: 'Função',
                newText: 'Cadastrar Função',
                table: 'rolesTable',
                columns: ['id', 'name', 'company_id', 'branch_id', 'sector_id', 'actions'],
                tableData: ['id', 'name', 'company_id', 'branch_id', 'sector_id'],
                options: {
                    filterByColumn: true,
                    debounce: 1000,
                    sortable: ['id', 'name', 'company_id', 'branch_id', 'sector_id'],
                    filterable: ['id', 'name', 'company_id', 'branch_id', 'sector_id'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'name': 'Nome',
                        'company_id': 'Empresa',
                        'branch_id': 'Unidade',
                        'sector_id': 'Departamento',
                        'id': '#',
                        'actions' : 'Ações'
                    },
                    templates: {
                        company_id: function(h, row, index){
                            return row.company.fantasy_name
                        },
                        branch_id: function(h, row, index){
                            return row.branch.name
                        },
                        sector_id: function(h, row, index){
                            return row.sector.name
                        }
                    },
                    requestFunction: function (data) {
                        let requestData = {};

                        let query = this.$parent.$parent.query(data.query);
                        requestData.params = data;
                        requestData.params.query = '';
                        requestData.params.with = [
                          'company',
                          'branch',
                          'sector'
                        ];

                        return this.$http
                            .get(this.url + '?' + query, requestData)
                            .catch(function (e) {
                                    this.dispatch("error", e);
                                }.bind(this)
                            );
                    }
                },
                endPoint: 'roles/',
                dataForm: {
                  title: {
                    add: 'Novo Cargo',
                    edit: 'Editar Cargo',
                    view: 'Visualizar Cargo',
                    icon: 'fa fa-pen'
                  },
                  button: {
                    back: '/roles'
                  },
                  url: {
                    model: 'roles'
                  },
                  messages: {
                    success: {
                      add: 'Cargo cadastrado com sucesso!',
                      edit: 'Cargo alterado com sucesso!'
                    }
                  },
                  fields: [
                    {
                      name: 'company_id',
                      model: 'company_id',
                      label: 'Empresa',
                      type: 'select',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|12|12",
                      offset: null,
                      list: [],
                      isRelated: [
                        'branch_id'
                      ],
                      list_label: 'fantasy_name'
                    },
                    {
                      name: 'branch_id',
                      model: 'branch_id',
                      label: 'Unidade',
                      type: 'select',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|12|12",
                      offset: null,
                      list: [],
                      isRelated: [
                        'sector_id'
                      ],
                    },
                    {
                      name: 'sector_id',
                      model: 'sector_id',
                      label: 'Departamento',
                      type: 'select',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|12|12",
                      offset: null,
                      list: []
                    },
                    {
                      name: 'name',
                      model: 'name',
                      label: 'Nome',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|12|12",
                      offset: null
                    }
                  ]
                }
            }
        },
        methods: {
          fieldUpdated: function(field){
            const self = this;
            if(field.model == 'company_id'){
              let filters = '&company_id=' + field.value
              self.getBranches(filters)
            } else if(field.model == 'branch_id'){
              let filters = '&branch_id=' + field.value
              self.getSectors(filters)
            }
          },
          query: function (query) {
              let columns = {
                  id: 'id',
                  name : 'name',
                  company_id: 'company[fantasy_name]',
                  branch_id: 'branch[name]',
                  sector_id: 'sector[name]',
                  role_id: 'role[name]',
                  cnpj: 'cnpj',
                  adress: 'adress',
              };
              let filters = '';
              $.each(query, function (index, value) {
                  filters += columns[index] + '=' + value + '&';
              });

              return filters;
          },
          getCompanies: function(filters){
            const self = this;
            const api = self.$store.state.api + 'companies?paginated=false' + (filters ? filters : '');
            self.$http.get(api)
              .then((response) => {
                let found = self.dataForm.fields.find(x => x.name == 'company_id')
                if(found){
                  found.list = response.data.data
                }
              }).catch((error) => {
                  self.$message('Erro', error.response.data, 'error');
              });
          },
          getBranches: function(filters){
            const self = this;
            const api = self.$store.state.api + 'branches?paginated=false' + (filters ? filters : '');
            self.$http.get(api)
              .then((response) => {
                let found = self.dataForm.fields.find(x => x.name == 'branch_id')
                if(found){
                  found.list = response.data.data
                }
              }).catch((error) => {
                  self.$message('Erro', error.response.data, 'error');
              });
          },
          getSectors: function(filters){
            const self = this;
            const api = self.$store.state.api + 'sectors?paginated=false' + (filters ? filters : '');
            self.$http.get(api)
              .then((response) => {
                let found = self.dataForm.fields.find(x => x.name == 'sector_id')
                if(found){
                  found.list = response.data.data
                }
              }).catch((error) => {
                  self.$message('Erro', error.response.data, 'error');
              });
          },
        },
        mounted() {
          const self = this;
          self.getCompanies();
          self.getBranches();
          self.getSectors();
        },
        components: {
            BaseCrud
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Role/Crud.vue